<template lang="pug">
div.pt-3.pb-8
  general-company-info
  v-divider.basic500.my-5
  general-page-language
  v-divider.basic500.my-5
  general-date-picker-view
  v-divider.basic500.my-5
  general-manual-payment

</template>

<script>
import GeneralCompanyInfo from '@/components/clinic/manage/GeneralCompanyInfo.vue'
import GeneralPageLanguage from '@/components/clinic/manage/GeneralPageLanguage.vue'
import GeneralDatePickerView from '@/components/clinic/manage/GeneralDatePickerView.vue'
import GeneralManualPayment from '@/components/clinic/manage/GeneralManualPayment.vue'

export default {
  name: 'ManageGeneral',
  components: { GeneralCompanyInfo, GeneralPageLanguage, GeneralDatePickerView, GeneralManualPayment },
}
</script>

<style scoped>

</style>